/**
 * Adapter so named imports from 'react-router-dom' work in Vite SSR and build.
 * Uses ESM build (index.mjs) via namespace import to avoid CJS "module is not defined".
 * Unwrap .default on component exports so we never pass an object as element type.
 */
import * as rr from 'react-router-dom-pkg'

const unwrap = (m) => (m && typeof m === 'object' && m.default != null ? m.default : m)

// ESM build has no default; namespace has all exports
export default rr
export const Link = unwrap(rr.Link)
export const NavLink = unwrap(rr.NavLink)
export const Navigate = unwrap(rr.Navigate)
export const Route = unwrap(rr.Route)
export const Routes = unwrap(rr.Routes)
export const useLocation = rr.useLocation
export const useNavigate = rr.useNavigate
export const useParams = rr.useParams
export const matchPath = rr.matchPath
export const BrowserRouter = unwrap(rr.BrowserRouter)
export const HashRouter = unwrap(rr.HashRouter)
export const StaticRouter = unwrap(rr.StaticRouter)
export const Form = unwrap(rr.Form)
export const Outlet = unwrap(rr.Outlet)
export const useSearchParams = rr.useSearchParams
export const useOutletContext = rr.useOutletContext
export const useRoutes = rr.useRoutes
export const MemoryRouter = unwrap(rr.MemoryRouter)
export const useInRouterContext = rr.useInRouterContext
